var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRentals({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5031 22.5435C22.595 25.8074 19.0536 28 15 28C8.92487 28 4 23.0751 4 17C4 10.9249 8.92487 6 15 6V17L24.5031 22.5435Z",
    fill: "#FF552E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1603 11.134C23.6386 10.8579 24.2502 11.0218 24.5264 11.5001C24.8025 11.9784 24.6386 12.5899 24.1603 12.8661L23.2943 13.3661C22.816 13.6422 22.2044 13.4784 21.9283 13.0001C21.6521 12.5218 21.816 11.9102 22.2943 11.634L23.1603 11.134Z",
    fill: "#FF552E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.134 7.83978C19.4102 7.36149 20.0218 7.19761 20.5001 7.47375C20.9784 7.7499 21.1422 8.36149 20.8661 8.83978L20.3661 9.70581C20.0899 10.1841 19.4784 10.348 19.0001 10.0718C18.5218 9.79569 18.3579 9.1841 18.634 8.70581L19.134 7.83978Z",
    fill: "#FF552E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 16C25.5523 16 26 16.4477 26 17C26 17.5523 25.5523 18 25 18H24C23.4477 18 23 17.5523 23 17C23 16.4477 23.4477 16 24 16H25Z",
    fill: "#FF552E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C11.4477 0 11 0.447715 11 1C11 1.55228 11.4477 2 12 2L12 2.30006C5.15328 3.68987 0 9.74313 0 17C0 25.2843 6.71573 32 15 32C23.2843 32 30 25.2843 30 17C30 9.74313 24.8467 3.68987 18 2.30005L18 2C18.5523 2 19 1.55228 19 1C19 0.447715 18.5523 0 18 0H12ZM15 30C19.7906 30 23.976 27.4087 26.231 23.5514C27.3555 21.6277 28 19.3891 28 17C28 9.8203 22.1797 4 15 4C7.8203 4 2 9.8203 2 17C2 24.1797 7.8203 30 15 30Z",
    fill: "#FF552E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRentals);
export default __webpack_public_path__ + "static/media/icon-rentals.869055032400d97cd9242e35dea5615e.svg";
export { ForwardRef as ReactComponent };